module.exports = __webpack_public_path__ + "img/moaning_myrtle.c64448ac.jpg";